<template>
  <div id="app" class="homepage">
    <h-r18-alert />
    <router-view></router-view>
  </div>
</template>

<script>
import HR18Alert from '@/components/HR18Alert.vue'

export default {
  name: 'App',
  components: {
    HR18Alert
  }
}
</script>

<style lang="scss">
#app.homepage {
  background-color: #1c1c1c;
  min-height: 100vh;
}
</style>